import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "service-payment-status page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "service-payment-status__inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_payment_status = _resolveComponent("payment-status")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_payment_status, { data: _ctx.status }, null, 8, ["data"])
      ])
    ])
  ]))
}